import { Button } from '@/components/ui/Button';
import type { InvestorSectionId } from './investor-sections';
import {
  INVESTOR_READINESS_KEY_LABELS,
  INVESTOR_READINESS_KEY_SECTION,
  isInvestorReadinessKey,
} from './investor-readiness';
import { INVESTOR_READINESS_STRINGS as S } from './investor-readiness.strings';

export interface InvestorMissingFieldsNoticeProps {
  /** The Backend's `matchingMissingFields`; the list is never worked out here. */
  missingFields?: readonly string[];
  /** Opens the panel that holds the chosen field. */
  onOpen: (section: InvestorSectionId) => void;
}

/**
 * "To be considered for matching, please complete the following fields:" with each
 * missing field named as it is on screen and opening the panel that holds it
 * (FR-186). Shown to editors only (the caller decides) and no percentage, as
 * profile-redesign A-156 and A-203 have it. Renders nothing when nothing is missing;
 * a key this app has no name for is skipped rather than shown by its raw name.
 */
export function InvestorMissingFieldsNotice({
  missingFields,
  onOpen,
}: InvestorMissingFieldsNoticeProps) {
  const keys = (missingFields ?? []).filter(isInvestorReadinessKey);
  if (keys.length === 0) return null;

  return (
    <section className="rounded-card border-attention bg-yellow/10 border border-dashed px-7 py-5">
      <p className="text-p5 text-navy font-semibold">{S.NOTICE_LEAD}</p>
      <ul className="mt-3 flex flex-wrap gap-x-5 gap-y-2">
        {keys.map((key) => (
          <li key={key}>
            <Button variant="link-sm" onClick={() => onOpen(INVESTOR_READINESS_KEY_SECTION[key])}>
              {INVESTOR_READINESS_KEY_LABELS[key]}
            </Button>
          </li>
        ))}
      </ul>
    </section>
  );
}
